/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import type {
  RibbonIconPreviewGallerySlots,
  RibbonIconPreviewGalleryState,
} from "./RibbonIconPreviewGallery.types";
import { assertSlots } from "@fluentui/react-components";

export const renderRibbonIconPreviewGallery = (
  state: RibbonIconPreviewGalleryState
) => {
  assertSlots<RibbonIconPreviewGallerySlots>(state);

  return <state.root />;
};
